// extracted by mini-css-extract-plugin
export default {"tooltip":"divkit-f1907","tooltip_visible":"divkit-e5914"};